// Auto-generated from PermissionKeys.cs - DO NOT EDIT MANUALLY
// Run: pnpm run generate-permissions

export const PermissionKeys = {
  User: {
    DashboardView: 'dashboard:view',
    ReportView: 'report:view',
    ProfileView: 'profile:view',
    ProfileUpdate: 'profile:update',
  },
  Tenant: {
    AgreementsList: 'agreements:list',
    AgreementCreate: 'agreement:create',
    CompaniesList: 'companies:list',
    CompanyCreate: 'company:create',
    ProductsList: 'products:list',
    ProductView: 'product:view',
    ProductCreate: 'product:create',
    ProductUpdate: 'product:update',
    ProductDelete: 'product:delete',
    SpacesList: 'spaces:list',
    SpaceCreate: 'space:create',
    DashboardView: 'dashboard:view',
    ProfileUpdate: 'tenant:profile:update',
    ProfileView: 'tenant:profile:view',
    ReportView: 'report:view',
    UsersList: 'users:list',
    UserView: 'user:view',
    UserDelete: 'user:delete',
    UserInvite: 'user:invite',
    UserUpdate: 'user:update',
    CompanyView: 'company:view',
    CompanyUpdate: 'company:update',
    CompanyDelete: 'company:delete',
    CompanyUsersList: 'company:users:list',
    CompanyUserInvite: 'company:user:invite',
    InvoicesView: 'invoices:view',
  },
  Space: {
    View: 'space:view',
    Update: 'space:update',
    Delete: 'space:delete',
    SubspacesCreate: 'space:subspaces:create',
    FinancialView: 'space:financial:view',
  },
  Agreement: {
    View: 'agreement:view',
    Create: 'agreement:create',
    Update: 'agreement:update',
    Delete: 'agreement:delete',
  },
  Product: {
    View: 'product:view',
    Update: 'product:update',
  },
} as const;

// Type for all permission key values
type PermissionKeysType = typeof PermissionKeys;
type PermissionScope = keyof PermissionKeysType;
type PermissionValue<S extends PermissionScope> = PermissionKeysType[S][keyof PermissionKeysType[S]];

export type PermissionKey = {
  [S in PermissionScope]: PermissionValue<S>;
}[PermissionScope];

// Helper to get all permission keys as array
export const allPermissionKeys: PermissionKey[] = Object.values(PermissionKeys).flatMap(
  (scope) => Object.values(scope)
) as PermissionKey[];
